import { Injectable } from '@angular/core';

/** Valentine's bundle: 1 magnet = 7.99, 2 magnets = 11.99 */
export const VALENTINES_SINGLE_PRICE = 7.99;
export const VALENTINES_BUNDLE_PRICE = 11.99;

/** Date range for Valentine's promo (inclusive). Month is 1-based. */
const VALENTINES_START = { month: 2, day: 1 };
const VALENTINES_END = { month: 2, day: 14 };

/** Variant IDs per store when Valentine's is active. Replace bundle IDs with real Shopify variant IDs after creating the 2-pack product in each store. */
const VALENTINES_VARIANT_IDS = {
  main: {
    singleVariantId: 'gid://shopify/ProductVariant/42366700585041',
    bundleVariantId: 'gid://shopify/ProductVariant/59043637166161'
  },
  nonMain: {
    singleVariantId: 'gid://shopify/ProductVariant/56263898431813',
    bundleVariantId: 'gid://shopify/ProductVariant/0' // TODO: Replace 0 with 2-pack variant ID from non-main Shopify store
  }
};

export interface ValentinesBundleConfig {
  singlePrice: number;
  bundlePrice: number;
}

@Injectable({
  providedIn: 'root'
})
export class PromoService {

  /**
   * Whether the Valentine's Day promo is currently active (date-based: 1–14 Feb, main shop only).
   */
  isValentinesActive(): boolean {
    // Only active for main shop
    const isMain = sessionStorage.getItem('main') === 'true';
    if (!isMain) return false;

    const now = new Date();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    if (month < VALENTINES_START.month || month > VALENTINES_END.month) return false;
    if (month === VALENTINES_START.month && day < VALENTINES_START.day) return false;
    if (month === VALENTINES_END.month && day > VALENTINES_END.day) return false;
    return true;
  }

  /**
   * Bundle total for Valentine's: floor(qty/2) * 11.99 + (qty % 2) * 7.99
   */
  getValentinesBundleTotal(quantity: number): number {
    const bundles = Math.floor(quantity / 2);
    const singles = quantity % 2;
    return bundles * VALENTINES_BUNDLE_PRICE + singles * VALENTINES_SINGLE_PRICE;
  }

  /**
   * Compare-at price for Valentine's (what user would pay without bundle): qty * 7.99
   */
  getValentinesCompareAtTotal(quantity: number): number {
    return quantity * VALENTINES_SINGLE_PRICE;
  }

  /**
   * Variant IDs to use when Valentine's is active, for the current shop (main vs non-main).
   */
  getValentinesVariantIds(): { singleVariantId: string; bundleVariantId: string } {
    const isMain = sessionStorage.getItem('main') === 'true';
    return isMain ? VALENTINES_VARIANT_IDS.main : VALENTINES_VARIANT_IDS.nonMain;
  }

  /**
   * Line items for checkout when Valentine's is active: bundle qty + single qty.
   */
  getValentinesLineItems(totalQuantity: number): Array<{ variantId: string; quantity: number }> {
    const ids = this.getValentinesVariantIds();
    const bundleQty = Math.floor(totalQuantity / 2);
    const singleQty = totalQuantity % 2;
    const lines: Array<{ variantId: string; quantity: number }> = [];
    if (bundleQty > 0) {
      lines.push({ variantId: ids.bundleVariantId, quantity: bundleQty });
    }
    if (singleQty > 0) {
      lines.push({ variantId: ids.singleVariantId, quantity: singleQty });
    }
    return lines;
  }

  getValentinesBundleConfig(): ValentinesBundleConfig {
    return {
      singlePrice: VALENTINES_SINGLE_PRICE,
      bundlePrice: VALENTINES_BUNDLE_PRICE
    };
  }
}
